import { render, staticRenderFns } from "./HistoryScreen.vue?vue&type=template&id=4991532e&scoped=true"
import script from "./HistoryScreen.vue?vue&type=script&lang=js"
export * from "./HistoryScreen.vue?vue&type=script&lang=js"
import style0 from "./HistoryScreen.vue?vue&type=style&index=0&id=4991532e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4991532e",
  null
  
)

export default component.exports